import { Component, Input, TemplateRef, ContentChild, ViewChild } from '@angular/core';
import type { ColumnType, ColumnAlign } from '../../models/components.models';

@Component({
  selector: 'app-list-table-column',
  standalone: true,
  template: '<ng-content></ng-content>',
})
export class ListTableColumnComponent {
  @Input() key?: string;
  @Input({ required: true }) title!: string;
  @Input({ required: true }) type!: ColumnType;
  @Input() sortable: boolean = false;
  @Input() align: ColumnAlign = 'center'; // alignement au centre par defaut 
  // "true" = toujours visible, "false" = jamais rendue ;
  // un breakpoint ("sm".."2xl") = visible a partir de cette largeur, masquee en dessous
  @Input() visible: "true" | "false" | "sm" | "md" | "lg" | "xl" | "2xl" = "true";
  @Input() showLabel: "true" | "false" = "true";

  // ContentChild pour mieux capturer le template
  @ContentChild(TemplateRef) customTemplate?: TemplateRef<any>;

  // accesseur au template
  getTemplate(): TemplateRef<any> | undefined {
    return this.customTemplate;
  }
}
